import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { fetchDashboard } from '@/services/readerService'
import { isPalavras } from '@/services/palavrasBrand'
import { PalavrasLogo } from '@/components/PalavrasLogo'

/** Persiste entre biblioteca e PDF; não sobrepõe os temas de acessibilidade. */
export function ReaderBrand() {
  const { data } = useQuery({ queryKey: ['student-dashboard'], queryFn: fetchDashboard })
  useEffect(() => {
    const color = data?.brand.primary_color
    if (color && /^#[0-9a-f]{6}$/i.test(color)) document.documentElement.style.setProperty('--lm-tenant', color)
    return () => { document.documentElement.style.removeProperty('--lm-tenant') }
  }, [data?.brand.primary_color])
  return null
}

export function ReaderBrandName() {
  const { data } = useQuery({ queryKey: ['student-dashboard'], queryFn: fetchDashboard })
  return <span className="app-brand">{isPalavras() ? <><PalavrasLogo />{data?.brand.name && !['Lúmina', 'Palavras Educação'].includes(data.brand.name) && <small>{data.brand.name}</small>}</> : data?.brand.name || 'Palavras Educação'}</span>
}
